"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageAttemptEndpointOut = void 0;
class MessageAttemptEndpointOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return MessageAttemptEndpointOut.attributeTypeMap;
    }
}
exports.MessageAttemptEndpointOut = MessageAttemptEndpointOut;
MessageAttemptEndpointOut.discriminator = undefined;
MessageAttemptEndpointOut.attributeTypeMap = [
    {
        "name": "endpointId",
        "baseName": "endpointId",
        "type": "string",
        "format": ""
    },
    {
        "name": "id",
        "baseName": "id",
        "type": "string",
        "format": ""
    },
    {
        "name": "msg",
        "baseName": "msg",
        "type": "MessageOut",
        "format": ""
    },
    {
        "name": "msgId",
        "baseName": "msgId",
        "type": "string",
        "format": ""
    },
    {
        "name": "response",
        "baseName": "response",
        "type": "string",
        "format": ""
    },
    {
        "name": "responseStatusCode",
        "baseName": "responseStatusCode",
        "type": "number",
        "format": "int16"
    },
    {
        "name": "status",
        "baseName": "status",
        "type": "MessageStatus",
        "format": ""
    },
    {
        "name": "timestamp",
        "baseName": "timestamp",
        "type": "Date",
        "format": "date-time"
    },
    {
        "name": "triggerType",
        "baseName": "triggerType",
        "type": "MessageAttemptTriggerType",
        "format": ""
    },
    {
        "name": "url",
        "baseName": "url",
        "type": "URI",
        "format": "uri"
    }
];
//# sourceMappingURL=MessageAttemptEndpointOut.js.map